export default {
    none: 0,
    /** sm radius. @deprecated */
    sm: 0,
    /** md radius. @deprecated */
    md: 2,
    /** lg radius. @deprecated */
    lg: 4,
    /** xl radius. @deprecated */
    xl: 6,
    round: 9999
};
